import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, MapPinned, Bell, Settings, Award } from "lucide-react";
import { useAuth } from "./auth";
import { isPublicPath } from "./seo/publicRoutes";

export default function BottomNav() {
  const { t } = useAuth();
  const loc = useLocation();
  // The signed-in app nav has no business on a public marketing page — it was
  // rendering over /faq for logged-out visitors. isPublicPath covers every
  // route in content.json, so new SEO pages are handled without edits here.
  if (
    isPublicPath(loc.pathname) ||
    loc.pathname === "/link" ||
    loc.pathname === "/onboarding"
  ) return null;

  const items = [
    { to: "/home",     label: t.home,     icon: Home,      test: "nav-home" },
    { to: "/trips",    label: t.trips,    icon: MapPinned, test: "nav-trips" },
    { to: "/alerts",   label: t.alerts,   icon: Bell,      test: "nav-alerts" },
    { to: "/reports",  label: t.reports,  icon: Award,     test: "nav-reports" },
    { to: "/settings", label: t.settings, icon: Settings,  test: "nav-settings" },
  ];

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-[500] px-3"
      style={{ paddingBottom: "max(12px, env(safe-area-inset-bottom))" }}
    >
      <div className="max-w-sm mx-auto">
        <div
          className="grid grid-cols-5 gap-0.5 p-1.5 rounded-2xl border border-surface-border"
          style={{
            background: "rgba(255,255,255,0.92)",
            backdropFilter: "blur(24px)",
            WebkitBackdropFilter: "blur(24px)",
            boxShadow: "0 -1px 0 rgba(15,23,42,0.04), 0 8px 32px -8px rgba(15,23,42,0.18), 0 2px 8px rgba(15,23,42,0.06)",
          }}
        >
          {items.map(({ to, label, icon: Icon, test }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={test}
              className={({ isActive }) =>
                `min-h-[48px] flex flex-col items-center justify-center gap-0.5 py-2 px-1 rounded-xl transition-all duration-200 ${
                  isActive
                    ? "bg-brand-600 text-white shadow-brand"
                    : "text-ink-muted hover:text-ink-soft hover:bg-surface-muted"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon size={19} strokeWidth={isActive ? 2.5 : 2} />
                  <span className={`text-[9px] font-bold tracking-wide ${isActive ? "text-white/90" : ""}`}>
                    {label}
                  </span>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
}
